export var AxisId;
(function (AxisId) {
    AxisId[AxisId["XL_AXIS_NONE"] = 0] = "XL_AXIS_NONE";
    AxisId[AxisId["XL_AXIS_X"] = 1] = "XL_AXIS_X";
    AxisId[AxisId["XL_AXIS_Y"] = 2] = "XL_AXIS_Y";
    AxisId[AxisId["XL_AXIS_Z"] = 3] = "XL_AXIS_Z";
    AxisId[AxisId["XL_AXIS_V"] = 4] = "XL_AXIS_V";
    AxisId[AxisId["XL_AXIS_V2"] = 5] = "XL_AXIS_V2";
})(AxisId || (AxisId = {}));
export var FeatureId;
(function (FeatureId) {
    FeatureId[FeatureId["ATYPE_NONE"] = 0] = "ATYPE_NONE";
    FeatureId[FeatureId["XL_FEATURE_MEAN"] = 1] = "XL_FEATURE_MEAN";
    FeatureId[FeatureId["XL_FEATURE_VAR"] = 2] = "XL_FEATURE_VAR";
    FeatureId[FeatureId["XL_FEATURE_ENERGY"] = 3] = "XL_FEATURE_ENERGY";
    FeatureId[FeatureId["XL_FEATURE_PEAKtoPEAK"] = 4] = "XL_FEATURE_PEAKtoPEAK";
    FeatureId[FeatureId["XL_FEATURE_ZERO_CROSSING"] = 5] = "XL_FEATURE_ZERO_CROSSING";
    FeatureId[FeatureId["XL_FEATURE_POS_ZERO_CROSSING"] = 6] = "XL_FEATURE_POS_ZERO_CROSSING";
    FeatureId[FeatureId["XL_FEATURE_NEG_ZERO_CROSSING"] = 7] = "XL_FEATURE_NEG_ZERO_CROSSING";
    FeatureId[FeatureId["XL_FEATURE_PEAK_DETECTOR"] = 8] = "XL_FEATURE_PEAK_DETECTOR";
    FeatureId[FeatureId["XL_FEATURE_POS_PEAK_DETECTOR"] = 9] = "XL_FEATURE_POS_PEAK_DETECTOR";
    FeatureId[FeatureId["XL_FEATURE_NEG_PEAK_DETECTOR"] = 10] = "XL_FEATURE_NEG_PEAK_DETECTOR";
    FeatureId[FeatureId["XL_FEATURE_MIN"] = 11] = "XL_FEATURE_MIN";
    FeatureId[FeatureId["XL_FEATURE_MAX"] = 12] = "XL_FEATURE_MAX";
})(FeatureId || (FeatureId = {}));
export var MonitorMode;
(function (MonitorMode) {
    MonitorMode["DIAGNOSTIC_MESSAGES"] = "DIAGNOSTIC_MESSAGES";
    MonitorMode["GENERAL_MESSAGES"] = "GENERAL_MESSAGES";
    MonitorMode["RAW"] = "RAW";
})(MonitorMode || (MonitorMode = {}));
export const possibleKeys = [
    'deviceId',
    'accountId',
    'customerDeviceId',
    'deviceEui',
    'deviceName',
    'deviceType',
    'messageId',
    'projectCode',
    'systemStage',
    'timestamp',
    'positionAgeYoung',
    'uplinkSizeLow',
    'downlinkConfigError',
    'batteryChargeStatus',
    'reboot',
    'downlinkAck',
    'batteryErr',
    'linkCheckErr',
    'cantering',
    'cast',
    'charging',
    'gpsKeepalive',
    'lipcurl',
    'lying',
    'move_av_vel',
    'move_curr_vel',
    'move_max_vel',
    'movement',
    'rearing',
    'standing',
    'steps',
    'trotting',
    'walking',
    'chardgin_condition',
    'chewing',
    'devTemp',
    'eating',
    'flankWatching',
    'hsTemp',
    'ir_amb_temp',
    'rolling',
    'teethGrinding',
    'xl_temp',
    'alertRolling',
    'foaling',
    'DOP',
    'age',
    'heading',
    'lat',
    'lng',
    'speed',
    'elevation',
    'activityXLRule',
    'averagingSetSize',
    'coldTimeout',
    'gpsRatePeriod',
    'maxDoP',
    'skipCount',
    'warmTimeout',
    'gpsAllFixesCount',
    'gpsDopStd',
    'gpsFixAvDuration',
    'gpsHeadingStd',
    'gpsLatitudeStd',
    'gpsLongitudeStd',
    'gpsRunningFixAvCount',
    'gpsSpeedStd',
];
export const defaultSelectedKeys = [
    'cantering',
    'cast',
    'charging',
    'gpsKeepalive',
    'lipcurl',
    'lying',
    'move_av_vel',
    'move_curr_vel',
    'move_max_vel',
    'movement',
    'rearing',
    'standing',
    'steps',
    'trotting',
    'walking',
];
